import { Redfast } from '@foxcorp/cpe-commerce-web';
import { getDefaultConfig } from 'Utils/Store';
import { createApiTokenHandler } from './Api/RefreshTokenHandler';

export const initRedfastActions = () => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  Redfast.createActions({
    apiKey: accountApiKey,
    apiUrl: foxApi,
  });

  // wrap Redfast actions in token handler so device registration/refresh token logic is applied
  // unlike Braze, Redfast from the commerce-web library doesn't expose a click function so we iterate through each
  //    prototype function to individually apply the token handler
  const redfastActions = Object.getPrototypeOf(window.FoxRedfast);
  for (const key of Object.getOwnPropertyNames(redfastActions)) {
    const originalMethod = redfastActions[key];
    redfastActions[key] = function () {
      return createApiTokenHandler(() => originalMethod.apply(this, arguments));
    };
  }
};

export const getHeaderZones = (pathname, routes) => {
  let path = pathname;
  if (pathname.slice(-1) === '/') {
    path = pathname.slice(0, -1);
  }

  switch (path) {
    case routes.signupCreateAccount:
    case routes.signupPlans:
    case routes.shipping:
    case routes.payment:
      return 'PromoBar';
    case routes.signupConfirmation:
      return 'PromoBarConfirmPage';
    case routes.myAccount:
      return 'PromoBarAccountPage';
    case routes.cancelPlan:
      return 'PromoBarCancelPage';
    case routes.changePlans:
      return 'PromoBarChangePlan';
    default:
      return '';
  }
};
